import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../../../shared/services/config/config.service";

@Injectable({
  providedIn: "root",
})
export class UssApiService {
  private apiBaseUrl = "";
  private url: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.apiBaseUrl = `${this.configService.getConfigProperty("API_URL")}`;
    this.url = `${this.apiBaseUrl}`;
  }

  get(
    endPoint: string,
    data: {
      params?: HttpParams;
    } = {},
    version: string = "v1"
  ) {
    let queryParams = data.params ? data.params : new HttpParams();
    return this.http.get<any>(`${this.url}/api/${version}/${endPoint}`, {
      params: queryParams,
    });
  }

  post(
    endPoint: string,
    data: any,
    params: {
      params?: HttpParams;
    } = {},
    version: string = "v1"
  ) {
    let queryParams = params.params ? params.params : new HttpParams();
    return this.http.post<any>(`${this.url}/api/${version}/${endPoint}`, data, {
      params: queryParams,
    });
  }

  put(endPoint: string, data: any, version: string = "v1") {
    return this.http.put<any>(`${this.url}/api/${version}/${endPoint}`, data);
  }

  delete(endPoint: string, data: any, version: string = "v1") {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: data,
    };
    return this.http.delete<any>(
      `${this.url}/api/${version}/${endPoint}`,
      options
    );
  }
}
